import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import AccordionItem from './accordion-item';
import {utilsService} from '../../core/services/utils.service';

@inject('store')
@observer
export default class Accordion extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.accordionStore = this.props.store.accordionStore;
    this.accordionStore.getSectionsIsAllowed();
    this.count=0;
    //this.props.store.getSectionsIsAllowed();
    //checking the screen is mobile or not
    
  }
  UNSAFE_componentWillUpdate(){
    var isMobile = window.orientation > -1;
    if(!isMobile){
      //if not mobile then default view of started videos will be expanded
      //if the name changes then please change it here also
      //console.log('sec empty'+this.props.store.isNewSecEmpty);
      if( this.count===0 && !this.props.store.isAdmin && !this.accordionStore.isAllowed)
      {
        //console.log('admin '+this.props.store.isAdmin+' allowed '+this.accordionStore.isAllowed);
        this.handleSectionToggle('Getting started videos');
        this.count++;
      }
      else if( this.count===0 && !this.props.store.isAdmin && this.accordionStore.isAllowed)
      {
          //console.log('if allowed '+ this.props.store.getFirstElementTitle());
          this.handleSectionToggle(this.props.store.getFirstElementTitle());
          this.count++;
      }
      else if( this.count===0 && this.props.store.isAdmin){
        //console.log('if allowed '+ this.props.store.getFirstElementTitle());
          this.handleSectionToggle(this.props.store.getFirstElementTitle());
          this.count++;
      }
      
    }
  }

  handleSectionToggle = (sectionTitle) => {
    this.accordionStore.handleSectionToggle(sectionTitle);
  }
  handelResetSearch=()=>{
    this.props.store.resetSearch();
}
  handleExpandAllToggle = (event) => {
    event.preventDefault();
    this.accordionStore.toggleEverythingIsExpanded();
  }
  handleLinkClick = (title,href) => {
    utilsService.tagLinkItem(title, 'Direct Link', href);
   }
  renderAccordionSections = () => {
    if (this.accordionStore.sections.length >0 ){
    return this.accordionStore.sections.map((category) => {
      if(this.props.store.newMasterStore.isInEditMode&&category.sectionId!=15){
      return (
        <AccordionItem
          key={category.sectionTitle}
          itemTitle={category.sectionTitle}
          itemArray={category.sectionItems}
          handleSectionToggle={this.handleSectionToggle}
          sectionId={category.sectionId}
          sectionType={category.sectionType}
          accordionStore={this.accordionStore}
          isInEditMode={this.props.store.newMasterStore.isInEditMode} />
      )
      }
      else{
        
        if(category.sectionItems.length!=0&&category.sectionId!=15){
          //if the name of these catagory changes then please change it here also
           
          if(category.sectionTitle ==='FirstNet Mission Control & FirstNet Mission IQ videos (New)'|| category.sectionTitle==='FirstNet Mission Control & FirstNet Mission IQ user guides (New)'){
            
            if (this.props.store.isAdmin || this.accordionStore.isAllowed){
              //console.log('2nd if '+this.accordionStore.isAllowed);
              
              return (
                <AccordionItem
                  key={category.sectionTitle}
                  itemTitle={category.sectionTitle}
                  itemArray={category.sectionItems}
                  handleSectionToggle={this.handleSectionToggle}
                  sectionId={category.sectionId}
                  sectionType={category.sectionType}
                  accordionStore={this.accordionStore}
                  isInEditMode={this.props.store.newMasterStore.isInEditMode} />
              )

            }

          }
          else
          {
            
            return (
              <AccordionItem
                key={category.sectionTitle}
                itemTitle={category.sectionTitle}
                itemArray={category.sectionItems}
                handleSectionToggle={this.handleSectionToggle}
                sectionId={category.sectionId}
                sectionType={category.sectionType}
                accordionStore={this.accordionStore}
                isInEditMode={this.props.store.newMasterStore.isInEditMode} />
            )

          }

        

      
      }
    }

    })
    }
    else
    return null
  }

  renderEndOfResult(){
    return this.props.store.resultCount> 0 ?
    <p className='result-end'>
      End of search results.
      <button className='reset-search' type='button' onClick={this.handelResetSearch}>
      <span className="sr-only"> Reset Search</span>
          Reset search?
       </button>
    </p>: '';
  }
  renderInstructorCard(){
    var temp=this.accordionStore.webinarSection;
    if(temp[0].sectionItems[0]!=undefined){
    return(

      <article className="row no-gutters accordion">
        {this.renderEndOfResult()}
          <div className="card" style={{marginTop:'30px'}}>
            <div className="container" style={{paddingLeft:'20px'}}>
               <div className="card-body">
                    <img src="/images/training_img.png" alt="training-instructor-image" className="card-image"/>
                    <h3 className="card-title">
                     {temp[0].sectionTitle}
                    </h3>
                    <p className="card-text">
                      {temp[0].sectionItems[0].description}
                    </p>
                <div className="card-link">
                    <a target="__blank" href={temp[0].sectionItems[0].href} role="button" onClick={()=>this.handleLinkClick(temp[0].sectionTitle,temp[0].sectionItems[0].href)} className="btn btn-secondary" style={{border: '2px solid #0568AE',borderRadius: '24px',minWidth: '305px',fontSize: '1.8rem',lineHeight: '48px',height: '48px',fontWeight: '700',textTransform:'none',color:'#0568AE',marginBottom:'20px'}}>Find webinars</a>
                </div>
                </div>
              </div>
          </div>
      
      </article>
      
    )
  }
    
  }

  renderExpandButton = () => {
    let expandedTextState = this.accordionStore.anythingIsExpanded
      ? 'Collapse all'
      : 'Expand all';
    return ( this.accordionStore.sections.length >0 ?
      <div className="accordion__toggleAll">
        <button
          className="accordion__toggleAll__button"
          aria-label={expandedTextState}
          aria-expanded={this.accordionStore.everythingIsExpanded}
          onClick={this.handleExpandAllToggle}
          type="button">
          {expandedTextState}
        </button>
      </div> : null
    )
  }
  
  render() {
    return (<React.Fragment>
      {(this.accordionStore.sections.length > 0|| this.accordionStore.webinarSection.length>0) &&
        <section className="accordion__list">
          <div className="container">
          {this.renderExpandButton()}
          {this.renderAccordionSections()}
          {this.renderInstructorCard()}
          </div>
        </section>
      }
    </React.Fragment>
    )
  }
}
